// Web mock for react-native-webview using iframe
import React from 'react';
import { View, StyleSheet } from 'react-native';

interface WebViewProps {
  source: { uri?: string; html?: string };
  style?: any;
  onLoad?: () => void;
  onError?: (error: any) => void;
  onMessage?: (event: any) => void;
  injectedJavaScript?: string;
  javaScriptEnabled?: boolean;
  domStorageEnabled?: boolean;
  startInLoadingState?: boolean;
  scalesPageToFit?: boolean;
  scrollEnabled?: boolean;
  originWhitelist?: string[];
  onNavigationStateChange?: (navState: any) => void;
}

const WebView: React.FC<WebViewProps> = ({
  source,
  style,
  onLoad,
  onError,
  onNavigationStateChange,
}) => {
  const iframeRef = React.useRef<HTMLIFrameElement>(null);

  const handleLoad = () => {
    onLoad?.();
    if (onNavigationStateChange && iframeRef.current) {
      try {
        onNavigationStateChange({
          url: iframeRef.current.contentWindow?.location.href || source?.uri || '',
          loading: false,
          canGoBack: false,
          canGoForward: false,
        });
      } catch {
        // Cross-origin restriction
      }
    }
  };

  if (source?.html) {
    return (
      <View style={[styles.container, style]}>
        <iframe
          ref={iframeRef}
          srcDoc={source.html}
          style={{ width: '100%', height: '100%', border: 'none' }}
          title="WebView"
          onLoad={handleLoad}
          onError={() => onError?.({ nativeEvent: { description: 'Load failed' } })}
        />
      </View>
    );
  }

  return (
    <View style={[styles.container, style]}>
      <iframe
        ref={iframeRef}
        src={source?.uri}
        style={{ width: '100%', height: '100%', border: 'none' }}
        title="WebView"
        onLoad={handleLoad}
        onError={() => onError?.({ nativeEvent: { description: 'Load failed' } })}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    overflow: 'hidden',
  },
});

export default WebView;
export { WebView };
